import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Avatar, Table } from 'antd';

import DownloadTable from 'components/download-table';

import './style.css';

const columns = [
  {
    title: 'Name',
    dataIndex: ['info', 'name'],
  },
  {
    title: 'Owner',
    dataIndex: ['owner', 'firstName'],
    render: (value, record) => {
      return (
        <Link to={`/employer-detail/${record.owner.id}`}>
          <Avatar
            src={record.owner.photoURL}
            style={{ marginRight: 'var(--margin-01)' }}
          />
          {value} {record.owner.lastName}
        </Link>
      );
    },
  },
  {
    title: 'Type',
    dataIndex: ['type', 'type'],
  },
  {
    title: 'Service',
    dataIndex: ['type', 'service'],
  },
  {
    title: 'Admins',
    dataIndex: ['admins', 'users'],
    render: (value) => {
      return (
        <ul>
          {value && value.map((item) => (
            <li key={item.uid}>
              <Link to={`/employer-detail/${item.uid}`}>
                {item.firstName} {item.lastName}
              </Link>
            </li>
          ))}
        </ul>
      );
    },
  },
];

const OrganizationsWidget = ({ users, organizations }) => {
  const data = organizations.map((organization) => {
    const user = users.find((item) => item.id === organization.userId);
    if (!user) return organization;
    return {
      ...organization,
      owner: {
        id: user.id,
        ...user.info,
      },
    };
  });

  return (
    <section className="admin-panel-section">
      <header className="admin-panel-header">
        <h2>Organizations</h2>
        <DownloadTable data={data} columns={columns} name="organizations" />
      </header>
      <Table dataSource={data} columns={columns} />
    </section>
  );
};

OrganizationsWidget.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};

export default OrganizationsWidget;
